export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

export const ADD_CUSTOMER_MONGO_REQUEST = "ADD_CUSTOMER_MONGO_REQUEST";
export const ADD_CUSTOMER_MONGO_SUCCESS = "ADD_CUSTOMER_MONGO_SUCCESS";
export const ADD_CUSTOMER_MONGO_FAILURE = "ADD_CUSTOMER_MONGO_FAILURE";
